import {LOCALE_ID, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {CardModule} from "primeng/card";
import {ButtonModule} from "primeng/button";
import {TableModule} from "primeng/table";
import {AccordionModule} from "primeng/accordion";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {DialogModule} from "primeng/dialog";
import {RippleModule} from "primeng/ripple";
import {InputTextareaModule} from "primeng/inputtextarea";
import {CheckboxModule} from "primeng/checkbox";
import {CalendarModule} from "primeng/calendar";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FileUploadModule} from "primeng/fileupload";
import {PasswordModule} from "primeng/password";
import {BrowserModule} from "@angular/platform-browser";
import {RadioButtonModule} from "primeng/radiobutton";
import {AvatarModule} from "primeng/avatar";
import {AutoCompleteModule} from "primeng/autocomplete";
import {RatingModule} from "primeng/rating";
import {InputSwitchModule} from "primeng/inputswitch";
import {InputNumberModule} from "primeng/inputnumber";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {ImgSecureLinkPipe} from "../../pipes/imgSecureLink";
import {HttpClientModule} from "@angular/common/http";
import {MultiSelectModule} from "primeng/multiselect";
import {StyleClassModule} from "primeng/styleclass";
import {TabViewModule} from 'primeng/tabview';
import {VirtualScrollerModule} from "primeng/virtualscroller";
import {PanelModule} from "primeng/panel";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {ProgressBarModule} from "primeng/progressbar";
import {DialogService} from "primeng/dynamicdialog";




@NgModule({
  declarations: [
    ImgSecureLinkPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    CardModule,
    ButtonModule,
    TableModule,
    AccordionModule,
    ProgressSpinnerModule,
    DialogModule,
    InputTextareaModule,
    RippleModule,
    CheckboxModule,
    CalendarModule,
    BrowserAnimationsModule,
    FileUploadModule,
    PasswordModule,
    BrowserModule,
    ReactiveFormsModule,
    CardModule,
    RadioButtonModule,
    AutoCompleteModule,
    RatingModule,
    InputSwitchModule,
    InputTextareaModule,
    InputNumberModule,
    ConfirmDialogModule,
    OverlayPanelModule,
    HttpClientModule,
    MultiSelectModule,
    StyleClassModule,
    TabViewModule,
    VirtualScrollerModule,
    PanelModule,
    PdfViewerModule,
    ProgressBarModule,
  ],
  providers: [
    DialogService,
    {provide: LOCALE_ID, useValue: 'it'}
  ],
  exports: [
    RippleModule,
    CommonModule,
    FormsModule,
    InputTextModule,
    CardModule,
    ButtonModule,
    TableModule,
    AccordionModule,
    ProgressSpinnerModule,
    DialogModule,
    InputTextareaModule,
    CheckboxModule,
    CalendarModule,
    BrowserAnimationsModule,
    FileUploadModule,
    PasswordModule,
    BrowserModule,
    ReactiveFormsModule,
    CardModule,
    RadioButtonModule,
    AvatarModule,
    AutoCompleteModule,
    RatingModule,
    InputSwitchModule,
    InputTextareaModule,
    InputNumberModule,
    ConfirmDialogModule,
    OverlayPanelModule,
    ImgSecureLinkPipe,
    HttpClientModule,
    MultiSelectModule,
    StyleClassModule,
    TabViewModule,
    VirtualScrollerModule,
    PanelModule,
    PdfViewerModule,
    ProgressBarModule
  ]
})
export class SharedModule { }
